import { useCallback, useEffect, useRef, useState } from 'react';

export function useForceUpdate() {
	const [, setState] = useState(true);
	const forceUpdate = useCallback(() => {
		setState((s) => !s);
	}, []);
	return forceUpdate;
}

export function useIsFirstRender() {
	const isFirstRenderRef = useRef(true);

	useEffect(() => {
		isFirstRenderRef.current = false;
	}, []);

	return isFirstRenderRef.current;
}

export function useIsMounted() {
	const isMountedRef = useRef(false);

	useEffect(() => {
		isMountedRef.current = true;

		return () => {
			isMountedRef.current = false;
		};
	}, []);

	return isMountedRef;
}

export function useIsInTransition() {
	const isFirstRender = useIsFirstRender();
	const isMountedRef = useIsMounted();

	return isFirstRender || !isMountedRef.current;
}
